// Each seat's model choice and the judge, kept in this browser. Nothing here is secret.
import { IDS } from "../lib/protocol.js";
import { SEATS, JUDGES } from "../lib/models.js";

const KEY = "chat-brawlers.models.v2";

// { ANTHROPIC: "claude-opus-5-5" | null, … }; null means the seat's default, as
// does a saved model that's no longer on the seat's menu.
export function load() {
  const choices = Object.fromEntries(IDS.map((id) => [id, null]));
  try {
    const saved = JSON.parse(window.localStorage.getItem(KEY) ?? "null");
    for (const id of IDS) if (SEATS[id].models.some((m) => m.id === saved?.[id])) choices[id] = saved[id];
  } catch {
    // Blocked or corrupt storage: defaults.
  }
  return choices;
}

// The judge model's id, or null for the default (also when it's off the menu).
const JUDGE_KEY = "chat-brawlers.judge";
export function loadJudge() {
  try {
    const saved = window.localStorage.getItem(JUDGE_KEY);
    return JUDGES.some((m) => m.id === saved) ? saved : null;
  } catch {
    return null;
  }
}
export function saveJudge(id) {
  try {
    window.localStorage.setItem(JUDGE_KEY, id);
  } catch {
    // Storage full or blocked: the choice still holds for this page view.
  }
}

// Whether to search the web before each question: on unless turned off.
const WEB_KEY = "chat-brawlers.web";
export function loadWeb() {
  try {
    return window.localStorage.getItem(WEB_KEY) !== "off";
  } catch {
    return true;
  }
}
export function saveWeb(on) {
  try {
    window.localStorage.setItem(WEB_KEY, on ? "on" : "off");
  } catch {
    // Storage full or blocked: the choice still holds for this page view.
  }
}

// How long the models' turns are: "short" (chat-length, the default) or "long".
const LENGTH_KEY = "chat-brawlers.length";
export function loadLength() {
  try {
    return window.localStorage.getItem(LENGTH_KEY) === "long" ? "long" : "short";
  } catch {
    return "short";
  }
}
export function saveLength(length) {
  try {
    window.localStorage.setItem(LENGTH_KEY, length);
  } catch {
    // Storage full or blocked: the choice still holds for this page view.
  }
}

// How fast turns are written out: "normal" (reading pace), "fast" (twice that, the
// default) or "instant" (as they arrive).
const SPEED_KEY = "chat-brawlers.speed";
const SPEEDS = ["normal", "fast", "instant"];
export function loadSpeed() {
  try {
    const s = window.localStorage.getItem(SPEED_KEY);
    return SPEEDS.includes(s) ? s : "fast";
  } catch {
    return "fast";
  }
}
export function saveSpeed(speed) {
  try {
    window.localStorage.setItem(SPEED_KEY, speed);
  } catch {
    // Storage full or blocked: the choice still holds for this page view.
  }
}

// How the brawl shows: "chat", one group thread (the default), or "columns".
const VIEW_KEY = "chat-brawlers.view";
export function loadView() {
  try {
    return window.localStorage.getItem(VIEW_KEY) === "columns" ? "columns" : "chat";
  } catch {
    return "chat";
  }
}
export function saveView(view) {
  try {
    window.localStorage.setItem(VIEW_KEY, view);
  } catch {
    // Storage full or blocked: the choice still holds for this page view.
  }
}

export function save(choices) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(choices));
  } catch {
    // Storage full or blocked: the choice still holds for this page view.
  }
}
